import { makeStyles } from 'tss-react/mui';

const NAV_WIDTH = 200;

export const useStyles = makeStyles()((theme) => ({
    root: {
        width: NAV_WIDTH,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(0.5),
        paddingRight: theme.spacing(3),
    },
    nav: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.25),
    },
    item: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.75),
        color: theme.palette.text.primary,
        borderRadius: theme.shape.borderRadius,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    itemSelected: {
        backgroundColor: theme.palette.action.selected,
        fontWeight: 600,
    },
}));
